import { useQuery } from "@tanstack/react-query";
import { api } from "../../../singleton/axios";
import { useMembership } from "../../../contexts/MembershipContext";
import { EngineCorpusStats } from "../types";

export const corpusStatsQueryKey = ["chat", "engine-stats"] as const;

// Fallback floor so the engine strip never animates "0 earnings calls" while
// the request races or fails — the endpoint's live value always wins. Update
// occasionally; being slightly stale-low only understates us.
export const CORPUS_STATS_FALLBACK: EngineCorpusStats = {
  calls: 49443,
  companies: 9081,
  passages: 650707,
};

/**
 * Insight Engine corpus scale for the search-status strip and done-chips.
 * Near-static (server caches 24h) — cache aggressively client-side too.
 */
export const useCorpusStats = (): EngineCorpusStats => {
  const { isMembershipActive } = useMembership();
  const { data } = useQuery<EngineCorpusStats, Error>({
    queryKey: corpusStatsQueryKey,
    enabled: isMembershipActive,
    queryFn: async () => {
      const res = await api.get<EngineCorpusStats>("/chat/engine-stats");
      return res.data;
    },
    staleTime: 24 * 60 * 60 * 1000,
    gcTime: 24 * 60 * 60 * 1000,
    placeholderData: CORPUS_STATS_FALLBACK,
    refetchOnWindowFocus: false,
  });
  return data ?? CORPUS_STATS_FALLBACK;
};
